module.exports = __webpack_public_path__ + "img/TSD.1dd81000.png";